// Node Modules
import { nanoid } from 'nanoid';

// Themes
import theme from '@/themes/index';

const Pagination = ({
  pageInfo,
  numberOfPages = 0,
  pageChange,
  activePage = 1,
  showPages = true,
}) => {
  const pagesArray = Array.from({
    length: numberOfPages,
  }, (x, i) => i+1);

  let pages = [];

  if (activePage === 1) {
    pages = pagesArray.slice(activePage-1, activePage+2);
  } else if(numberOfPages-2 > activePage) {
    pages = pagesArray.slice(activePage-2, activePage+1);
  } else {
    pages = pagesArray.slice(numberOfPages-3);
  }

  return (
    <>
      <div className='pagination'>
        <a
          className='previous-button' 
          onClick={() => pageChange && pageChange(pageInfo.startCursor, 'previous')}
        >
          Previous
        </a>
        {showPages && pages.map(page => (
          <span 
            style={{
              color: activePage === (page) && theme.fontColors.optional4,
              fontWeight: activePage === (page) && 'bold',
            }} 
            key={nanoid()}>{page}</span>
        ))}
        <a
          className='next-button'
          onClick={() => pageChange && pageChange(pageInfo.endCursor, 'next')}
        >
          Next
        </a>
      </div>
      <style jsx>{`
        div.pagination {
          margin-top: 2rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          min-height: 5rem;
          border-top: 1px solid ${theme.fontColors.optional3};
          border-bottom: 1px solid ${theme.fontColors.optional3};
          align-items: center;
          gap: 1.375rem;
        }

        div.pagination a {
          cursor: pointer;
        }

        div.pagination a.previous-button {
          pointer-events: ${!pageInfo?.hasPreviousPage && 'none'};
          color: ${!pageInfo?.hasPreviousPage && theme.fontColors.optional3}
        }

        div.pagination a.next-button {
          pointer-events: ${!pageInfo?.hasNextPage && 'none'};
          color: ${!pageInfo?.hasNextPage && theme.fontColors.optional3}
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.pagination {
            margin-top: 10rem;
          }
        }
      `}</style>
    </>
  );
};

export default Pagination;
